export enum SendContractFormType {
  LEAD = "lead",
  CONTACT = "contact",
}
